


















































import Toast from '@/shared/services/toast';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { IntentListItemViewModel } from '../models/intents/intentListItemViewModel';
import AddIntentModal from '@/features/bots/components/designer/AddIntentModal.vue';
import { LOAD_INTENTS } from '@/store/intents/actionTypes';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import EditIntentModal from '@/features/bots/components/designer/EditIntentModal.vue';
import DeleteIntentModal from '@/features/bots/components/designer/DeleteIntentModal.vue';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';

library.add(faSearch);

@Component({
	components: {
		LoadingSpinner,
		AddIntentModal,
		EditIntentModal,
		DeleteIntentModal,
		DropDownMenu,
		DeleteIcon
	}
})
export default class Intents extends Vue {
	@Getter public intents!: IntentListItemViewModel[];

	@Action(LOAD_INTENTS) public loadIntents!: (forceLoad?: boolean) => Promise<void>;

	public loading = false;
	public intentToEdit: IntentListItemViewModel = { id: '', title: '', utteranceCount: 0, references: [] };

	public deleteModalVisible: boolean = false;
	public intentToDelete: IntentListItemViewModel | null = null;

	public tableColumns = [
		{
			display: 'Intent',
			name: 'title',
			clickable: true
		},
		{
			display: 'Utterances',
			name: 'utteranceCount'
		}
	];

	public async mounted() {
		await this.getIntents();
	}

	public async getIntents(): Promise<void> {
		this.loading = true;
		try {
			await this.loadIntents(true);
		} catch (error: any) {
			Toast.showError(error.message);
		}
		this.loading = false;
	}

	public get sortedIntents(): IntentListItemViewModel[] {
		return this.intents.sort((a, b) => a.title.localeCompare(b.title));
	}

	public addIntent() {
		if (this.$refs.addIntentModal) {
			(this.$refs.addIntentModal as AddIntentModal).addNewIntent();
		}
	}

	public editIntent(intent: IntentListItemViewModel) {
		this.intentToEdit = intent;
		this.$nextTick(() => {
			if (this.$refs.editIntentModal) {
				(this.$refs.editIntentModal as EditIntentModal).showModal();
			}
		});
	}

	public showDeleteModal(intent: IntentListItemViewModel) {
		this.intentToDelete = intent;
		this.deleteModalVisible = true;
	}
}
